export const product = {
    back: 'Volver',
    loading: 'Cargando producto...',
    inStock: 'En stock',
    outOfStock: 'Sin stock',
    features: 'Características',
    specifications: 'Especificaciones Técnicas',
    warranty: 'Garantía',
    shipping: 'Envío',
    specificationsLabels: {
        battery: 'Batería',
        flightTime: 'Tiempo de Vuelo',
        range: 'Alcance',
        weight: 'Peso',
        camera: 'Cámara',
        gimbal: 'Gimbal',
        obstacleAvoidance: 'Detección de Obstáculos',
        maxSpeed: 'Velocidad Máxima',
        maxAltitude: 'Altitud Máxima',
    },
    notFound: {
        title: 'Producto no encontrado',
        description: 'El producto que buscas no fue encontrado.',
        backToCatalog: 'Volver al catálogo',
    },
    video: {
        title: 'Vídeo Demostrativo',
        description: 'Mira el drone en acción y conoce todas sus funcionalidades',
    },
};
//# sourceMappingURL=product.js.map